import { useQuery } from '@apollo/client';
import * as Sentry from '@sentry/react';

import ThirdPartyOrganizationAuthoringPartnerQuery from 'bundles/enterprise-admin-home/queries/ThirdPartyOrganizationAuthoringPartner.graphql';
import type {
  ThirdPartyOrganizationAuthoringPartnerQuery as Query,
  ThirdPartyOrganizationAuthoringPartnerQueryVariables as Variables,
} from 'bundles/enterprise-admin-home/queries/__generated__/ThirdPartyOrganizationAuthoringPartner';

export const useThirdPartyOrgAuthoringPartnerQuery = (thirdPartyOrganizationId: string) => {
  const { data, loading, error, refetch } = useQuery<Query, Variables>(ThirdPartyOrganizationAuthoringPartnerQuery, {
    variables: { thirdPartyOrganizationId },
    skip: !thirdPartyOrganizationId,
    fetchPolicy: 'cache-and-network',
    context: { clientName: 'gatewayGql' },
    errorPolicy: 'all',
    ssr: false,
    onCompleted: (result) => {
      const partnerId =
        result?.NaptimeQueries.EnterpriseAuthoringMappingsV1Resource.byThirdPartyOrganizationId?.elements[0]?.partner
          ?.id;

      if (partnerId && isNaN(Number(partnerId))) {
        Sentry.captureException(
          'Error in useThirdPartyOrgAuthoringPartnerQuery. PartnerId is defined, but is not a number.',
          {
            extra: {
              message: 'ThirdPartyOrganizartion is not returning a valid partnerId',
              thirdPartyOrganizationId,
            },
          }
        );
      }
    },
  });

  const authoringPartners =
    data?.NaptimeQueries.EnterpriseAuthoringMappingsV1Resource.byThirdPartyOrganizationId?.elements;

  return { authoringPartners, loading, error, refetch };
};
